// 👉 headers

import i18n from '@/plugins/i18n'

export const clustersHeaders = [
  { title: 'ID', key: 'id' },
  { title: 'Cluster Name', key: 'place_name', width: 750 },
  { title: 'Created Timestamp', key: 'created_at', align: 'start' },
  { title: 'Updated Timestamp', key: 'updated_at', align: 'start' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]
export const routesHeaders = [
  { title: 'ID', key: 'id' },
  { title: 'Route Name', key: 'place_name', width: 500 },
  { title: 'Display Name', key: 'display_name' },
  { title: 'Created Timestamp', key: 'created_at', align: 'start' },
  { title: 'Updated Timestamp', key: 'updated_at', align: 'start' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const materialsHeaders = [
  { title: 'ID', key: 'id' },
  { title: 'Material/Products Name', key: 'name', width: 750 },
  { title: 'Created Timestamp', key: 'created_at', align: 'start' },
  { title: 'Updated Timestamp', key: 'updated_at', align: 'start' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const smsHeaders = [
  { title: 'ID', key: 'id' },
  { title: 'SMS Header Name', key: 'name', width: 750 },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const industriesHeaders = [
  { title: 'ID', key: 'id' },
  { title: 'Industry Name', key: 'name', width: 750 },
  { title: 'Created Timestamp', key: 'created_at', align: 'start' },
  { title: 'Updated Timestamp', key: 'updated_at', align: 'start' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const conditionsHeaders = [
  { title: 'ID', key: 'id' },
  { title: 'Condition Name', key: 'name', width: 550 },
  { title: 'Section', key: 'type' },
  { title: 'Created Timestamp', key: 'created_at', align: 'start' },
  { title: 'Updated Timestamp', key: 'updated_at', align: 'start' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const remarkHeaders = [
  { title: 'ID', key: 'id' },
  { title: 'Code', key: 'code', width: 200 },
  { title: 'Description', key: 'description', width: 550 },
  { title: 'Created Timestamp', key: 'created_at', align: 'start' },
  { title: 'Updated Timestamp', key: 'updated_at', align: 'start' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const documentTypeHeaders = [
  { title: 'ID', key: 'id' },
  { title: 'Document Name', key: 'name', width: 300 },
  { title: 'Section', key: 'type', align: 'start' },
  { title: 'Is Primary', key: 'is_primary', sortable: false, align: 'start' },
  { title: 'Is Confidential', key: 'is_public', sortable: false, align: 'start' },
  { title: 'Has Expiry', key: 'has_expiry', sortable: false, align: 'start' },
  { title: 'Created Timestamp', key: 'created_at', align: 'start' },
  { title: 'Updated Timestamp', key: 'updated_at', align: 'start' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const messageTemplate = [
  { title: 'ID', key: 'id' },
  { title: 'DLT Template ID', key: 'templateId' },
  { title: 'Template Name', key: 'name' },
  { title: 'Template Type', key: 'templateType' },
  { title: 'Category', key: 'category' },
  { title: 'Sub Category', key: 'subCategory' },
  { title: 'Created Timestamp', key: 'createdAt', align: 'start' },
  { title: 'Updated Timestamp', key: 'updatedAt', align: 'start' },
  { title: 'Status', key: 'isActive' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const documentHeaders = [
  { title: 'Doc ID', key: 'id', sortable: false },
  { title: 'Document Name', key: 'name', width: 400, sortable: false },
  { title: '', key: '', align: '', sortable: false },
  { title: 'CNF ID', key: 'owner.confirmation.formatted_id', align: 'start', is_bold: true },
  { title: 'Document Section', key: 'type', align: 'start', sortable: false },
  { title: '', key: '', align: '', sortable: false },
  { title: 'Booking ID', key: 'business_id', align: 'start', sortable: false, is_bold: true },
  { title: 'Has Expiry', key: 'has_expiry', sortable: false, align: 'start' },
  { title: 'Is Confidential', key: 'is_public', sortable: false, align: 'start' },
  { title: 'Business Name / ID', key: 'business_name', align: 'start', sortable: false, is_bold: true },
  { title: 'Valid From', key: 'valid_from', align: 'start', sortable: false },
  { title: 'Is Primary', key: 'is_primary', sortable: false, align: 'start' },
  { title: 'Created Timestamp', key: 'created_at', align: 'start' },
  { title: 'Valid To', key: 'valid_to', align: 'start', sortable: false },
  { title: 'Status', key: 'status', align: 'start', sortable: false, is_bold: true },
  { title: 'Updated Timestamp', key: 'updated_at', align: 'start' },
  { title: '', key: '', align: '', sortable: false },
  { title: 'Remarks', key: 'reason', align: 'start', sortable: false },
]

export const rejectDocumentHeaders = [
  { title: 'Document Name', key: 'name' },
  { title: 'Document Section', key: 'type' },
  { title: 'Business Name', key: 'business_name' },
  { title: 'Confirmation ID', key: 'owner.confirmation.formatted_id' },
  { title: 'Is Primary', key: 'is_primary' },
  { title: 'Is Confidential', key: 'is_public' },
  { title: 'Has Expiry', key: 'has_expiry' },
  { title: 'Valid From', key: 'valid_from' },
  { title: 'Valid To', key: 'valid_to' },
]

export const documentTypesHeaders = [
  { title: 'ID', key: 'id' },
  { title: 'Document Name', key: 'name' },
  { title: 'Is Primary', key: 'is_primary', sortable: false, align: 'start' },
  { title: 'Is Confidential', key: 'is_public', sortable: false, align: 'start' },
  { title: 'Valid From', key: 'valid_from', align: 'start' },
  { title: 'Valid To', key: 'valid_to', align: 'center' },
  { title: 'Status', key: 'status', align: 'start' },
  { title: 'Rejection Reason', key: 'reason', sortable: false, align: 'start' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'start' },
]

export const notificationsHeaders = [
  { title: i18n.global.t('ID'), key: 'id' },
  { title: i18n.global.t('Notification Title'), key: 'title', align: 'start' },
  { title: i18n.global.t('Notification Message'), key: 'message', width: 600, align: 'start' },
  { title: i18n.global.t('Date & Time'), key: 'created_at', align: 'start' },
  { title: i18n.global.t('Status'), key: 'is_read' },
  { title: i18n.global.t('Actions'), key: 'actions', sortable: false, align: 'center' },
]

export const usersNotificationsHeaders = [
  { title: 'Notification Title', key: 'notification_title', width: 1100, align: 'start', sortable: false },
  { title: 'Date & Time', key: 'date_time', align: 'start', sortable: false },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const mastersMcBookHeaders = [
  { title: 'ID', key: 'id', sortable: false },
  { title: 'Full Name', key: 'fullname', sortable: false },
  {
    title: 'Mobile No.',
    key: 'mobile',
    align: 'start',
    sortable: false,
  },
  {
    title: 'Landline No.',
    key: 'landline',
    align: 'start',
    sortable: false,
  },
  { title: 'Email Address', key: 'email', align: 'start', sortable: false },
  { title: 'Designation', key: 'designation', align: 'start', sortable: false },
  { title: 'Work With', key: 'work_with', align: 'start', sortable: false },
  { title: 'Primary Name', key: 'owner.user.fullname', align: 'start', sortable: false },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const driversHeaders = [
  { title: 'ID', key: 'id', sortable: false },
  { title: 'Name', key: 'fullname', sortable: false },
  {
    title: 'Mobile',
    key: 'mobiles',
    align: 'start',
    sortable: false,

    render(item: any) {
      return item.columns.mobiles?.[0]?.value
    },
  },
  {
    title: 'Landline',
    key: 'landlines',
    align: 'start',
    sortable: false,

    render(item: any) {
      return item.columns.landlines?.[0]?.value
    },
  },
  { title: 'Email Address', key: 'email', align: 'start', sortable: false },
  { title: 'Designation', key: 'designation', align: 'start', sortable: false },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const branchesHeaders = [
  { title: 'ID', key: 'id', sortable: false },
  { title: 'Business Name', key: 'business_name', align: 'start' },
  { title: 'Trading Name', key: 'trading_name', align: 'start', sortable: false },
  { title: 'Area', key: 'bank_ifsc_code', align: 'start', sortable: false },
  { title: 'Charges', key: 'bank_branch_address', align: 'start', sortable: false },
  {
    title: 'Mobile',
    key: 'mobiles',
    align: 'start',
    sortable: false,

    render(item: any) {
      return item.columns.mobiles?.[0]?.value
    },
  },
  {
    title: 'Landline',
    key: 'landlines',
    align: 'start',
    sortable: false,

    render(item: any) {
      return item.columns.landlines?.[0]?.value
    },
  },
  { title: 'Email Address', key: 'email', align: 'start', sortable: false },
  { title: 'Designation', key: 'designation', align: 'start', sortable: false },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const bannerHeaders = [
  { title: 'Thumbnail', key: 'url', width: 250, sortable: false },
  { title: 'Banner Title', key: 'name', sortable: false },
  { title: 'User Type', key: 'type', sortable: false },
  { title: 'Created Timestamp', key: 'created_at', align: 'start' },
  { title: 'Updated Timestamp', key: 'updated_at', align: 'start' },
  { title: 'Actions', key: 'actions', align: 'center', width: 150, sortable: false },
]

export const publicBasicInfoColumns = [
  { name: i18n.global.t('Loading Date'), value: 'confirmationDate' },
  { name: i18n.global.t('Loading Points'), value: 'loadingPoints' },
  { name: i18n.global.t('Unloading Points'), value: 'unloadingPoints' },
  { name: i18n.global.t('Truck No.'), value: 'truckNumber' },
  { name: i18n.global.t('Tyres'), value: 'tyres' },
  { name: i18n.global.t('Capacity / No. of Units'), value: 'capacity' },
  { name: i18n.global.t('Per Ton / Per Unit Price'), value: 'freightAmount' },
  { name: i18n.global.t('Freight Method'), value: 'freightMethod' },
  { name: i18n.global.t('Total Freight'), value: 'totalAmount' },

  // { name: i18n.global.t('Adv.'), value: 'advanceAmount', condition: false },
  // { name: i18n.global.t('To Pay'), value: 'toPayAmount', condition: false },
  // { name: i18n.global.t('POD'), value: 'podAmount', condition: false },
]

export const adminBasicInfoColumns = [
  { name: i18n.global.t('Loading Date'), value: 'confirmationDate' },
  { name: i18n.global.t('Truck No.'), value: 'truckNumber' },
  { name: i18n.global.t('Loading Points'), value: 'loadingPoints' },
  { name: i18n.global.t('Unloading Points'), value: 'unloadingPoints' },
  { name: i18n.global.t('Capacity / No. of Units'), value: 'capacity' },
  { name: i18n.global.t('Freight Method'), value: 'freightMethod' },
  { name: i18n.global.t('Truck Freight'), value: 'freightAmount', tooltip: i18n.global.t('Truck Freight = Truck Freight + Additional Freight') },
  { name: i18n.global.t('PR'), value: 'pr' },
  { name: i18n.global.t('OR'), value: 'or' },
  { name: i18n.global.t('Misc.'), value: 'misc' },
  { name: i18n.global.t('Total Freight'), value: 'totalAmount' },
]

export const truckerBasicInfoColumns = [
  { name: i18n.global.t('Loading Date'), value: 'confirmationDate' },
  { name: i18n.global.t('Truck No.'), value: 'truckNumber' },
  { name: i18n.global.t('Loading Points'), value: 'loadingPoints' },
  { name: i18n.global.t('Unloading Points'), value: 'unloadingPoints' },
  { name: i18n.global.t('Capacity / No. of Units'), value: 'capacity' },
  { name: i18n.global.t('Freight Method'), value: 'freightMethod' },
  { name: i18n.global.t('Truck Freight'), value: 'freight', tooltip: i18n.global.t('Truck Freight = Truck Freight + Additional Freight') },
  { name: i18n.global.t('CROSSING'), value: 'crossing' },
  { name: i18n.global.t('Total Freight'), value: 'totalAmount' },
]

export const loaderBasicInfoColumns = [
  { name: i18n.global.t('Loading Date'), value: 'confirmationDate' },
  { name: i18n.global.t('Truck No.'), value: 'truckNumber' },
  { name: i18n.global.t('Loading Points'), value: 'loadingPoints' },
  { name: i18n.global.t('Unloading Points'), value: 'unloadingPoints' },
  { name: i18n.global.t('Capacity / No. of Units'), value: 'capacity' },
  { name: i18n.global.t('Freight Method'), value: 'freightMethod' },
  { name: i18n.global.t('Truck Freight'), value: 'freight', tooltip: i18n.global.t('Truck Freight = Truck Freight + Additional Freight') },
  { name: i18n.global.t('PR'), value: 'pr' },
  { name: i18n.global.t('Total Freight'), value: 'totalAmount' },
]

export const loaderTotalPayment = {
  freightMethod: 'freightMethod',
  capacity: 'capacity',
  totalFreight: 'totalFreight',
  freightReceiveAdmin: 'freightReceiveAdmin',
  freight: 'freight',
  pr: 'pr',
  additionalCharges: 'additionalCharges',
}

export const paymentStructure = [
  { title: i18n.global.t('Advance Payment'), value: 'advanceAmountTrucker' },
  { title: i18n.global.t('To Pay Amount'), value: 'toPayAmountTrucker' },
  { title: i18n.global.t('POD Amount'), value: 'podAmountTrucker' },
]

export const paymentStructureLoader = [
  { title: i18n.global.t('Advance Payment'), value: 'advanceAmount' },
  { title: i18n.global.t('To Pay Amount'), value: 'toPayAmount' },
  { title: i18n.global.t('POD Amount'), value: 'podAmount' },
]

export const truckerFreightMethod = ['freightMethod', 'freightValue', 'additionalCharges', 'crossing', 'totalFreightTrucker']

export const truckerPaymentToPay = [
  'crossing', 'commission', 'crossingCommission',
]

export const confirmationAdminLoaderInfoColumns = [
  { name: i18n.global.t('Load ID'), value: 'id' },
  { name: i18n.global.t('Business Area'), value: 'placeName' },
  { name: i18n.global.t('Business Name'), value: 'businessName' },
  { name: i18n.global.t('Loader ID'), value: 'loaderId' },
  { name: i18n.global.t('Business cluster'), value: 'clusterPlace' },
  { name: i18n.global.t('Trading Name'), value: 'tradingName' },
  { name: i18n.global.t('Primary Name'), value: 'fullname' },
  { name: i18n.global.t('Alternative Name'), value: 'altContact' },
  { name: 'Load Availability Date', value: 'loadingDate' },
  { name: i18n.global.t('Primary Mobile No'), value: 'preferredContact' },
  { name: i18n.global.t('Alternative Mobile No'), value: 'altContactMobile' },
  { name: i18n.global.t('Email Address'), value: 'email' },
  { name: i18n.global.t('Conditions'), value: 'conditions' },
  { name: i18n.global.t('Targeted Route'), value: 'targetedRoute' },
  { name: i18n.global.t('Loading Cluster'), value: 'loadingCluster' },
  { name: i18n.global.t('Industry'), value: 'industry' },
  { name: i18n.global.t(''), value: '' },
  { name: i18n.global.t('Total Distance'), value: 'totalDistance' },
  { name: i18n.global.t('Materials/Products'), value: 'materials' },
  { name: i18n.global.t(''), value: '' },
  { name: i18n.global.t('Notes'), value: 'notes' },
]

export const confirmationLoaderInfoColumns = [
  { name: i18n.global.t('Load ID'), value: 'id' },
  { name: i18n.global.t('Primary Name'), value: 'fullname' },
  { name: i18n.global.t('Business Name'), value: 'businessName' },
  { name: i18n.global.t('Loader ID'), value: 'loaderId' },
  { name: i18n.global.t('Primary Mobile No'), value: 'preferredContact' },
  { name: i18n.global.t('Trading Name'), value: 'tradingName' },
  { name: i18n.global.t('Industry'), value: 'industry' },
  { name: i18n.global.t('Alternative Name'), value: 'altContact' },
  { name: i18n.global.t('Business Area'), value: 'placeName' },
  { name: i18n.global.t('Materials/Products'), value: 'materials' },
  { name: i18n.global.t('Alternative Mobile No'), value: 'altContactMobile' },
  { name: i18n.global.t('Email Address'), value: 'email' },
  { name: i18n.global.t('Conditions'), value: 'conditions' },
  { name: 'Load Availability Date', value: 'loadingDate' },
  { name: i18n.global.t('Notes'), value: 'notes' },
]

export const invoiceLoaderInfoColumns = [
  { name: i18n.global.t('Load ID'), value: 'id' },
  { name: i18n.global.t('Primary Name'), value: 'fullname' },
  { name: i18n.global.t('Business Name'), value: 'businessName' },
  { name: i18n.global.t('Loader ID'), value: 'loaderId' },
  { name: i18n.global.t('Primary Mobile No'), value: 'preferredContact' },
  { name: i18n.global.t('Trading Name'), value: 'tradingName' },
  { name: i18n.global.t('Industry'), value: 'industry' },
  { name: i18n.global.t('Alternative Name'), value: 'altContact' },
  { name: i18n.global.t('Address'), value: 'address' },
  { name: i18n.global.t('Materials/Products'), value: 'materials' },
  { name: i18n.global.t('Alternative Mobile No'), value: 'altContactMobile' },
  { name: i18n.global.t('Business Area'), value: 'placeName' },
  { name: i18n.global.t('Conditions'), value: 'conditions' },
  { name: i18n.global.t('Notes'), value: 'notes' },
  { name: i18n.global.t('Email Address'), value: 'email' },
]

export const confirmationTruckerInfoColumns = [
  { name: i18n.global.t('Offer ID'), value: 'id' },
  { name: i18n.global.t('Primary Name'), value: 'fullname' },
  { name: i18n.global.t('Business Name'), value: 'businessName' },
  { name: i18n.global.t('Trucker ID'), value: 'truckerId' },
  { name: i18n.global.t('Primary Mobile No'), value: 'ownerContact' },
  { name: i18n.global.t('Trading Name'), value: 'tradingName' },
  { name: i18n.global.t('Pref. Routes'), value: 'preferredRoutes' },
  { name: i18n.global.t('Alternative Name'), value: 'alternateName' },
  { name: i18n.global.t('Business Area'), value: 'placeName' },
  { name: i18n.global.t('Pref. Materials/Products'), value: 'materials' },
  { name: i18n.global.t('Alternative Mobile No'), value: 'altContactMobile' },
  { name: i18n.global.t('Email Address'), value: 'email' },
  { name: i18n.global.t('Truck No.'), value: 'truckNumber' },
  { name: i18n.global.t('Driver Name'), value: 'driverName' },
  { name: i18n.global.t('Driver License No.'), value: 'licenseNumber' },
  { name: i18n.global.t('Tyres'), value: 'tyres' },
  { name: i18n.global.t('Driver Mobile No.'), value: 'driverMobile' },
  { name: i18n.global.t('Truck Available Area'), value: 'offerPlaceName' },
  { name: i18n.global.t('Capacity'), value: 'capacity' },
  { name: i18n.global.t('Chassis No.'), value: 'chassisNumber' },
  { name: i18n.global.t('Engine No.'), value: 'engineNumber' },
  { name: i18n.global.t('Conditions'), value: 'conditions' },
  { name: 'Offer Availability Date', value: 'loadingDate' },
  { name: i18n.global.t('Notes'), value: 'notes' },
]

export const confirmationAdminTruckerInfoColumns = [
  { name: i18n.global.t('Offer ID'), value: 'id' },
  { name: i18n.global.t('Business Area'), value: 'placeName' },
  { name: i18n.global.t('Business Name'), value: 'businessName' },

  { name: i18n.global.t('Trucker ID'), value: 'truckerId' },
  { name: i18n.global.t('Business Cluster'), value: 'businessCluster' },
  { name: i18n.global.t('Trading Name'), value: 'tradingName' },

  { name: i18n.global.t('Primary Name'), value: 'fullname' },
  { name: i18n.global.t('Driver Name'), value: 'driverName' },
  { name: i18n.global.t('Truck No.'), value: 'truckNumber' },

  { name: i18n.global.t('Primary Mobile No'), value: 'ownerContact' },
  { name: i18n.global.t('Driver Mobile No.'), value: 'driverMobile' },
  { name: i18n.global.t('Tyres'), value: 'tyres' },

  { name: i18n.global.t('Email Address'), value: 'email' },
  { name: i18n.global.t('Driver License No.'), value: 'licenseNumber' },
  { name: i18n.global.t('Capacity'), value: 'capacity' },

  { name: i18n.global.t('Alternative Name'), value: 'alternateName' },
  { name: i18n.global.t('Pref. Routes'), value: 'preferredRoutes' },
  { name: i18n.global.t('Engine No.'), value: 'engineNumber' },

  { name: i18n.global.t('Alternative Mobile No'), value: 'altContactMobile' },
  { name: i18n.global.t('Pref. Materials/Products'), value: 'materials' },
  { name: i18n.global.t('Chassis No.'), value: 'chassisNumber' },

  { name: 'Offer Availability Date', value: 'loadingDate' },
  { name: i18n.global.t('Conditions'), value: 'conditions' },
  { name: i18n.global.t('Truck Available Area'), value: 'offerPlaceName' },

  { name: i18n.global.t('Lead Distance'), value: 'leadDistance' },
  { name: i18n.global.t('Notes'), value: 'notes' },
  { name: i18n.global.t('Offer Cluster'), value: 'offerCluster' },
]

export const loadingPointColumns = [
  { name: i18n.global.t('Business Name'), value: 'businessName' },
  { name: i18n.global.t('Area'), value: 'placeName' },
  { name: i18n.global.t('Map URL'), value: 'mapUrl' },
  { name: i18n.global.t('Capacity'), value: 'capacity' },
  { name: i18n.global.t('Loading Charges'), value: 'charges' },
  { name: 'Full Name', value: 'fullname' },
  { name: 'Designation', value: 'designation' },
  { name: 'Email Address', value: 'email' },
  { name: i18n.global.t('Address'), value: 'address' },
  { name: i18n.global.t('Pincode'), value: 'pincode' },
  { name: i18n.global.t('Mobile No.'), value: 'mobile' },
  { name: 'Landline No.', value: 'landline' },
]

export const unloadingPointColumns = [
  { name: i18n.global.t('Business Name'), value: 'businessName' },
  { name: i18n.global.t('Area'), value: 'placeName' },
  { name: i18n.global.t('Map URL'), value: 'mapUrl' },
  { name: i18n.global.t('Capacity'), value: 'capacity' },
  { name: i18n.global.t('Unloading Charges'), value: 'charges' },
  { name: 'Full Name', value: 'fullname' },
  { name: 'Designation', value: 'designation' },
  { name: 'Email Address', value: 'email' },
  { name: i18n.global.t('Address'), value: 'address' },
  { name: i18n.global.t('Pincode'), value: 'pincode' },
  { name: i18n.global.t('Mobile No.'), value: 'mobile' },
  { name: 'Landline No.', value: 'landline' },
]
export const preCnfloadingPointColumns = [
  { name: i18n.global.t('Business Name'), value: 'businessName' },
  { name: i18n.global.t('Area'), value: 'placeName' },
  { name: i18n.global.t('Loading Cluster'), value: 'clusterName' },
  { name: i18n.global.t('Capacity'), value: 'capacity' },
  { name: i18n.global.t('Loading Charges'), value: 'charges' },
  { name: 'Full Name', value: 'fullname' },
  { name: 'Designation', value: 'designation' },
  { name: 'Email Address', value: 'email' },
  { name: i18n.global.t('Address'), value: 'address' },
  { name: i18n.global.t('Preferred Contact No.'), value: 'mobile' },
  { name: 'Landline No.', value: 'landline' },

]

export const loadingPointsDialogColumns = [
  { name: i18n.global.t('Business Name'), value: 'businessName' },
  { name: i18n.global.t('Loading Point'), value: 'placeName' },
  { name: i18n.global.t('Mobile No.'), value: 'preferredContact' },
  { name: i18n.global.t('Charges'), value: 'charges' },
]

export const unloadingPointsDialogColumns = [
  { name: i18n.global.t('Business Name'), value: 'businessName' },
  { name: i18n.global.t('Unloading Point'), value: 'placeName' },
  { name: i18n.global.t('Mobile No.'), value: 'preferredContact' },
  { name: i18n.global.t('Charges'), value: 'charges' },
]

export const podDocumentUpload = [
  { label: 'POD Amount', value: '' },
  { label: 'Invoice', value: '' },
  { label: 'Challan', value: '' },
  { label: 'Document', value: '' },
]

export const podDocuments = {
  isPhyPodReceivedTrucker: '1. Physical POD documents received from trucker',
  isPhyPodSubmittedLoader: '2. Physical POD documents submitted to loader',
  isPodReceivedLoader: '3. POD amount received from loader',
  isPodPaidTrucker: '4. POD amount paid to trucker',
}

export const documentUpload = [
  { label: 'Way Bill', value: '' },
  { label: 'Invoice', value: '' },
  { label: 'Document:', value: '' },
]

export const truckerDocuments = [
  { label: 'Insurance' },
  { label: 'License' },
  { label: 'RC Book' },
  { label: 'NOC Letter' },
]

export const paymentInfoHeaders = [
  { name: 'Bank Name', value: 'bankName', key: 'bankName' },
  { name: 'Account No.', value: 'accountNo', key: 'bankNumber' },
  { name: 'Account Name', value: 'accountName', key: 'accountName' },
  { name: 'IFSC Code', value: 'ifscCode', key: 'bankIfscCode' },
  { name: 'Branch Name', value: 'branchName', key: 'bankBranchAddress' },
  { name: 'Account Type', value: 'accountType', key: 'bankType' },
]

export const usersDashboardHeaders = [
  { title: 'Route', key: 'route', sortable: false },
  { title: 'Total Available', key: 'total_available', align: 'start' },
  { title: 'Sizes', key: 'sizes', align: 'start', sortable: false },
  { title: 'Market', key: 'market', align: 'start', sortable: false },
  { title: 'Available', key: 'available', align: 'start', sortable: false },
  { title: 'Truck No.', key: 'truck_no', align: 'start', sortable: false },
  { title: 'No. of CNF', key: 'no_of_cnf', align: 'end', sortable: false },
]

export const smsOrWhatsappLogsHeaders = [
  { title: i18n.global.t('general.campaign'), key: 'campaign', sortable: false },
  { title: i18n.global.t('reports.template_name'), key: 'template_name', sortable: false },
  { title: i18n.global.t('reports.template_id'), key: 'template_id', align: 'start', sortable: false },
  { title: i18n.global.t('reports.template'), key: 'template', sortable: false },
  { title: i18n.global.t('Date & Time'), key: 'date_time', align: 'start', sortable: false },
  { title: i18n.global.t('reports.total_counts'), key: 'total_counts', align: 'start', sortable: false },
  { title: i18n.global.t('reports.sms_status'), key: 'status', align: 'center', sortable: false },
]

export const transactionsHeaders = [
  { title: 'ID', key: 'id', sortable: false },
  { title: 'Transaction ID', key: 'transactionId', sortable: false },
  { title: 'Transaction Date', key: 'createdAt', align: 'start' },
  { title: 'CNF ID', key: 'cnfId', sortable: false },
  { title: 'Description', key: 'description', sortable: false },
  { title: 'Amount', key: 'amount' },
  { title: 'Status', key: 'status', sortable: false },
]

export const auditLogsHeaders = [
  { title: 'Module', key: 'id', sortable: false },
  { title: 'Role', key: 'role' },
  { title: 'Email', key: 'email', sortable: false },
  { title: 'Event', key: 'name' },
  { title: 'Created At', key: 'created_at', align: 'start' },
  { title: 'Details', key: 'details', align: 'center' },
]

export const globalSearchLoaderTruckerHeaders = [
  { title: 'ID', key: 'id', sortable: false },
  { title: 'Business Name', key: 'businessName' },
  { title: 'Trading Name', key: 'tradingName' },
  { title: 'Primary Name', key: 'fullname' },
  {
    title: 'Mobile',
    key: 'mobiles',
    align: 'start',
    sortable: false,
  },

  {
    title: 'Landline',
    key: 'landlines',
    align: 'start',
    sortable: false,

    render(item: any) {
      return item?.[0]?.value
    },
  },

  // Not sortable: the backend maps every sortField except `fullname` onto the owning table
  // (`loaders.email` / `truckers.email`), which has no email column.
  { title: 'Email', key: 'email', align: 'start', sortable: false },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const globalSearchTruckerHybridHeaders = [
  ...globalSearchLoaderTruckerHeaders.slice(0, -1),
  { title: 'Matching Truck No.', key: 'matchingTruckNumbers', align: 'start', sortable: false },
  ...globalSearchLoaderTruckerHeaders.slice(-1),
]

export const globalSearchEmployeeHeaders = [
  { title: 'ID', key: 'id', sortable: false },
  { title: 'Business Name', key: 'employable_id.businessName' },
  { title: 'Trading Name', key: 'employable_id.tradingName' },
  { title: 'Employee Name', key: 'fullname' },
  {
    title: 'Mobile',
    key: 'mobiles',
    align: 'start',
    sortable: false,
  },

  {
    title: 'Landline',
    key: 'landlines',
    align: 'start',
    sortable: false,

    render(item: any) {
      return item?.[0]?.value
    },
  },

  { title: 'Email', key: 'email', align: 'start', sortable: false },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const deleteUserRequestsHeaders = [
  { title: i18n.global.t('delete_users.search.id'), key: 'id', sortable: false },
  { title: i18n.global.t('delete_users.search.email'), key: 'email', align: 'start', sortable: true },
  { title: i18n.global.t('delete_users.search.mobile'), key: 'mobile', align: 'start', sortable: true },
  { title: i18n.global.t('delete_users.search.role'), key: 'userType', align: 'start', sortable: true },
  { title: i18n.global.t('delete_users.search.delete_type'), key: 'deleteType', align: 'start', sortable: true },
  { title: i18n.global.t('delete_users.search.status'), key: 'status', align: 'start', sortable: true },
]

export const globalSearchDriverHeaders = [
  { title: 'ID', key: 'id', sortable: false },
  { title: 'Business Name', key: 'employable_id.businessName' },
  { title: 'Trading Name', key: 'employable_id.tradingName' },
  { title: 'Driver Name', key: 'fullname' },
  {
    title: 'Mobile',
    key: 'mobiles',
    align: 'start',
    sortable: false,
  },

  {
    title: 'Landline',
    key: 'landlines',
    align: 'start',
    sortable: false,

    render(item: any) {
      return item?.[0]?.value
    },
  },

  { title: 'Email', key: 'email', align: 'start', sortable: false },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const loadingPointHeader = [
  { title: 'Select', key: 'select', sortable: false, width: '5%,', fieldKey: 'select' },
  { title: 'Business Name', key: 'businessName', sortable: false, width: '10%', fieldKey: 'businessName' },
  { title: 'Address', key: 'address', sortable: false, width: '10%', fieldKey: 'address' },
  { title: 'Place Name', key: 'placeName', sortable: false, width: '10%', fieldKey: 'location' },
  { title: 'Material', key: 'material', sortable: false, width: '10%', fieldKey: 'material' },
  {
    title: 'Capacity',
    key: 'capacity',
    sortable: false,
    width: '10%',
    fieldKey: 'capacity',
  },
  { title: 'Freight', key: 'totalAmount', sortable: false, width: '10%', fieldKey: 'totalFreight' },
  { title: 'Preferred Name', key: 'fullname', sortable: false, width: '10%', fieldKey: 'contactName' },
  { title: 'Contact No.', key: 'preferredContact', sortable: false, width: '10%', fieldKey: 'contactNumber' },
  { title: 'GST No.', key: 'gstNumber', sortable: false, width: '10%', fieldKey: 'gstNumber' },
  { title: 'Actions', key: 'actions', sortable: false, width: '5%', fieldKey: 'actions' },
]

export const unloadingPointHeader = [
  { title: 'Select', key: 'select', sortable: false, width: '5%', fieldKey: 'select' },
  { title: 'Business Name', key: 'businessName', sortable: false, width: '10%', fieldKey: 'businessName' },
  { title: 'Address', key: 'address', sortable: false, width: '10%', fieldKey: 'address' },
  { title: 'Place Name', key: 'placeName', sortable: false, width: '10%', fieldKey: 'location' },
  { title: 'Material', key: 'material', sortable: false, width: '10%', fieldKey: 'material' },
  {
    title: 'Capacity',
    key: 'capacity',
    sortable: false,
    width: '10%',
    fieldKey: 'capacity',
  },
  { title: 'Freight', key: 'totalAmount', sortable: false, width: '10%', fieldKey: 'totalFreight' },
  { title: 'Preferred Name', key: 'fullname', sortable: false, width: '10%', fieldKey: 'contactName' },
  { title: 'Contact No.', key: 'preferredContact', sortable: false, width: '10%', fieldKey: 'contactNumber' },
  { title: 'GST No.', key: 'gstNumber', sortable: false, width: '10%', fieldKey: 'gstNumber' },
  { title: 'Actions', key: 'actions', sortable: false, width: '5%', fieldKey: 'actions' },
]

export const editLoadingInvoiceHeader = [
  { title: 'Select', key: 'select', sortable: false, width: '5%', fieldKey: 'select' },
  { title: 'Business Name', key: 'businessName', sortable: false, width: '10%', fieldKey: 'businessName' },
  { title: 'Address', key: 'address', sortable: false, width: '10%', fieldKey: 'address' },
  { title: 'Place Name', key: 'location', sortable: false, width: '10%', fieldKey: 'location' },
  { title: 'Material', key: 'material', sortable: false, width: '10%', fieldKey: 'material' },
  { title: 'Capacity', key: 'capacity', sortable: false, width: '10%', fieldKey: 'capacity' },
  { title: 'Freight', key: 'totalFreight', sortable: false, width: '10%', fieldKey: 'totalFreight' },
  { title: 'Preferred Name', key: 'contactName', sortable: false, width: '10%', fieldKey: 'contactName' },
  { title: 'Contact No.', key: 'contactNumber', sortable: false, width: '10%', fieldKey: 'contactNumber' },
  { title: 'GST No.', key: 'gstNumber', sortable: false, width: '10%', fieldKey: 'gstNumber' },
  { title: 'Actions', key: 'actions', sortable: false, width: '5%', fieldKey: 'actions' },
]

export const editUnloadingInvoiceHeader = [
  { title: 'Select', key: 'select', sortable: false, width: '5%', fieldKey: 'select' },
  { title: 'Business Name', key: 'businessName', sortable: false, width: '10%', fieldKey: 'businessName' },
  { title: 'Address', key: 'address', sortable: false, width: '10%', fieldKey: 'address' },
  { title: 'Place Name', key: 'location', sortable: false, width: '10%', fieldKey: 'location' },
  { title: 'Material', key: 'material', sortable: false, width: '10%', fieldKey: 'material' },
  { title: 'Capacity', key: 'capacity', sortable: false, width: '10%', fieldKey: 'capacity' },
  { title: 'Freight', key: 'totalFreight', sortable: false, width: '10%', fieldKey: 'totalFreight' },
  { title: 'Preferred Name', key: 'contactName', sortable: false, width: '10%', fieldKey: 'contactName' },
  { title: 'Contact No.', key: 'contactNumber', sortable: false, width: '10%', fieldKey: 'contactNumber' },
  { title: 'GST No.', key: 'gstNumber', sortable: false, width: '10%', fieldKey: 'gstNumber' },
  { title: 'Actions', key: 'actions', sortable: false, width: '5%', fieldKey: 'actions' },
]

export const contactEnquiriesHeaders = [
  { title: 'ID', key: 'id', sortable: false },
  { title: 'Name', key: 'name', align: 'start', sortable: false },
  { title: 'Contact No.', key: 'contactNo', align: 'start', sortable: false },
  { title: 'Email', key: 'email', align: 'start', sortable: false },
  { title: 'Subject', key: 'subject', sortable: false },
  { title: 'Message', key: 'message', sortable: false },
  { title: 'Created At', key: 'createdAt', sortable: false },
]

export const iGSTHeader = [
  { title: 'No.', key: 'no', sortable: false, width: '5%', fieldKey: 'no' },
  { title: 'Item Description', key: 'description', sortable: false, width: '28%', fieldKey: 'description' },
  { title: 'Qty.', key: 'quantity', sortable: false, width: '10%', fieldKey: 'quantity' },
  { title: 'Unit', key: 'unit', sortable: false, width: '12%', fieldKey: 'unit' },
  { title: 'Price/UNIT (With Tax)', key: 'pricePerUnit', sortable: false, width: '10%', fieldKey: 'pricePerUnit' },
  { title: 'Taxable Amount', key: 'taxableAmount', sortable: false, width: '10%', fieldKey: 'taxableAmount' },

  // { title: 'Discount', key: 'discount', sortable: false, width: '10%', fieldKey: 'discount' },
  { title: 'IGST Tax @18%', key: 'igst', sortable: false, width: '10%', fieldKey: 'igst' },
  { title: 'Total Amount', key: 'totalAmount', sortable: false, width: '10%', fieldKey: 'totalAmount' },
  { title: 'Actions', key: 'actions', sortable: false, width: '5%', fieldKey: 'actions' },
]

export const cGSTHeader = [
  { title: 'No.', key: 'no', sortable: false, width: '5%', fieldKey: 'no' },
  { title: 'Item Description', key: 'description', sortable: false, width: '23%', fieldKey: 'description' },
  { title: 'Qty.', key: 'quantity', sortable: false, width: '10%', fieldKey: 'quantity' },
  { title: 'Unit', key: 'unit', sortable: false, width: '12%', fieldKey: 'unit' },
  { title: 'Price/UNIT (With Tax)', key: 'pricePerUnit', sortable: false, width: '10%', fieldKey: 'pricePerUnit' },
  { title: 'Taxable Amount', key: 'taxableAmount', sortable: false, width: '10%', fieldKey: 'taxableAmount' },

  // { title: 'Discount', key: 'discount', sortable: false, width: '5%', fieldKey: 'discount' },
  { title: 'CGST Tax @9%', key: 'cgst', sortable: false, width: '10%', fieldKey: 'cgst' },
  { title: 'SGST Tax @9%', key: 'sgst', sortable: false, width: '10%', fieldKey: 'sgst' },
  { title: 'Total Amount', key: 'totalAmount', sortable: false, width: '10%', fieldKey: 'totalAmount' },
  { title: 'Actions', key: 'actions', sortable: false, width: '5%', fieldKey: 'actions' },
]
